import configData from "../config/config.json";

export const postUserStat = async(username, element, detail) => {
    try{
        const url = configData.CCBHTableauAPIServer + "/stat";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({
                    "username": username,
                    "elementName": element,
                    "detail": detail
                }),
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    } 
};

export const addStat = async(username, elementName, detail) => {
    return await postUserStat(username, elementName, detail);
};
